// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.game-header-sponsor-section {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 16px;
}

.game-header-sponsor-logos {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 16px;
}

.game-header-sponsor-logo {
  display: block;
  object-fit: contain;
}
@media (max-width: 767px) {
  .game-header-sponsor-logo {
    max-height: 85px;
  }
}
@media (min-width: 768px) {
  .game-header-sponsor-logo {
    max-height: 150px;
  }
}

.game-header-sponsor-link {
  text-decoration: underline;
  cursor: pointer;
  font-weight: 700;
}
@media (max-width: 767px) {
  .game-header-sponsor-link {
    font-size: 12px;
  }
}
@media (min-width: 768px) {
  .game-header-sponsor-link {
    font-size: 16px;
  }
}

.game-header-header-container {
  display: flex;
  width: 100%;
  flex-direction: column;
}

.game-header-header-content {
  display: flex;
  width: 100%;
  padding: 4px 10px 0 10px;
  justify-content: space-between;
  align-items: baseline;
}
@media (max-width: 767px) {
  .game-header-header-content {
    height: 32px;
  }
}
@media (min-width: 768px) {
  .game-header-header-content {
    height: 68px;
    align-items: center;
  }
}

.game-header-back-button {
  display: flex;
  align-items: center;
  cursor: pointer;
}

@media (max-width: 767px) {
  .game-header-back-icon {
    font-size: 10px !important;
    margin-left: 0;
  }
}
@media (min-width: 768px) {
  .game-header-back-icon {
    font-size: 14px !important;
    margin-left: 25px;
  }
}

.game-header-back-text {
  margin-left: 4px !important;
  font-weight: 500 !important;
}
@media (max-width: 767px) {
  .game-header-back-text {
    font-size: 12px !important;
  }
}
@media (min-width: 768px) {
  .game-header-back-text {
    font-size: 16px !important;
  }
}

.game-header-header-title {
  font-weight: 700 !important;
  white-space: nowrap;
}
@media (max-width: 767px) {
  .game-header-header-title {
    font-size: 16px !important;
    margin-right: 0;
  }
}
@media (min-width: 768px) {
  .game-header-header-title {
    font-size: 28px !important;
    margin-right: 32px;
  }
}

/* Default styles (mobile first) */
.game-header-header-title.game-header-header-title-long-name {
  font-weight: 700 !important;
  white-space: nowrap;
  font-size: 12px !important;
  margin-right: 0 !important;
}

/* Medium phones */
@media (min-width: 450px) and (max-width: 767px) {
  .game-header-header-title.game-header-header-title-long-name {
    font-size: 16px !important;
    margin-right: 0 !important;
  }
}
/* Larger screens */
@media (min-width: 768px) {
  .game-header-header-title.game-header-header-title-long-name {
    font-size: 28px !important;
    margin-right: 32px !important;
  }
}
.game-header-modal-buttons {
  display: flex;
  gap: 10px;
}`, "",{"version":3,"sources":["webpack://./src/components/PoolHeaderBar/GameHeaderTemplate.scss"],"names":[],"mappings":"AAEA;EACI,WAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AADJ;;AAIE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,SAAA;AADJ;;AAIE;EACE,cAAA;EACA,mBAAA;AADJ;AAGI;EAJF;IAKI,gBAAA;EAAJ;AACF;AAEI;EARF;IASI,iBAAA;EACJ;AACF;;AAEE;EACE,0BAAA;EACA,eAAA;EACA,gBAAA;AACJ;AACI;EALF;IAMI,eAAA;EAEJ;AACF;AAAI;EATF;IAUI,eAAA;EAGJ;AACF;;AAAE;EACE,aAAA;EACA,WAAA;EACA,sBAAA;AAGJ;;AAAE;EACE,aAAA;EACA,WAAA;EACA,wBAAA;EACA,8BAAA;EACA,qBAAA;AAGJ;AADI;EAPF;IAQI,YAAA;EAIJ;AACF;AAFI;EAXF;IAYI,YAAA;IACA,mBAAA;EAKJ;AACF;;AAFE;EACE,aAAA;EACA,mBAAA;EACA,eAAA;AAKJ;;AADI;EADF;IAEI,0BAAA;IACA,cAAA;EAKJ;AACF;AAHI;EANF;IAOI,0BAAA;IACA,iBAAA;EAMJ;AACF;;AAHE;EACE,2BAAA;EACA,2BAAA;AAMJ;AAJI;EAJF;IAKI,0BAAA;EAOJ;AACF;AALI;EARF;IASI,0BAAA;EAQJ;AACF;;AALE;EACE,2BAAA;EACA,mBAAA;AAQJ;AANI;EAJF;IAKI,0BAAA;IACA,eAAA;EASJ;AACF;AAPI;EATF;IAUI,0BAAA;IACA,kBAAA;EAUJ;AACF;;AAPE,kCAAA;AACA;EACE,2BAAA;EACA,mBAAA;EACA,0BAAA;EACA,0BAAA;AAUJ;;AAPE,kBAAA;AACA;EACE;IACI,0BAAA;IACA,0BAAA;EAUN;AACF;AAPE,mBAAA;AACA;EACE;IACI,0BAAA;IACA,6BAAA;EASN;AACF;AACE;EACE,aAAA;EACA,SAAA;AACJ","sourcesContent":["// GameHeaderTemplate.scss\n\n.game-header-sponsor-section {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    padding: 16px;\n  }\n\n  .game-header-sponsor-logos {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    gap: 16px;\n  }\n\n  .game-header-sponsor-logo {\n    display: block;\n    object-fit: contain;\n\n    @media (max-width: 767px) {\n      max-height: 85px;\n    }\n\n    @media (min-width: 768px) {\n      max-height: 150px;\n    }\n  }\n\n  .game-header-sponsor-link {\n    text-decoration: underline;\n    cursor: pointer;\n    font-weight: 700;\n\n    @media (max-width: 767px) {\n      font-size: 12px;\n    }\n\n    @media (min-width: 768px) {\n      font-size: 16px;\n    }\n  }\n\n  .game-header-header-container {\n    display: flex;\n    width: 100%;\n    flex-direction: column;\n  }\n\n  .game-header-header-content {\n    display: flex;\n    width: 100%;\n    padding: 4px 10px 0 10px;\n    justify-content: space-between;\n    align-items: baseline;\n\n    @media (max-width: 767px) {\n      height: 32px;\n    }\n\n    @media (min-width: 768px) {\n      height: 68px;\n      align-items: center;\n    }\n  }\n\n  .game-header-back-button {\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n  }\n\n  .game-header-back-icon {\n    @media (max-width: 767px) {\n      font-size: 10px !important;\n      margin-left: 0;\n    }\n\n    @media (min-width: 768px) {\n      font-size: 14px !important;\n      margin-left: 25px;\n    }\n  }\n\n  .game-header-back-text {\n    margin-left: 4px !important;\n    font-weight: 500 !important;\n\n    @media (max-width: 767px) {\n      font-size: 12px !important;\n    }\n\n    @media (min-width: 768px) {\n      font-size: 16px !important;\n    }\n  }\n\n  .game-header-header-title {\n    font-weight: 700 !important;\n    white-space: nowrap;\n\n    @media (max-width: 767px) {\n      font-size: 16px !important;\n      margin-right: 0;\n    }\n\n    @media (min-width: 768px) {\n      font-size: 28px !important;\n      margin-right: 32px;\n    }\n  }\n\n  /* Default styles (mobile first) */\n  .game-header-header-title.game-header-header-title-long-name {\n    font-weight: 700 !important;\n    white-space: nowrap;\n    font-size: 12px !important;\n    margin-right: 0 !important;\n  }\n\n  /* Medium phones */\n  @media (min-width: 450px) and (max-width: 767px) {\n    .game-header-header-title.game-header-header-title-long-name {\n        font-size: 16px !important;\n        margin-right: 0 !important;\n    }\n  }\n\n  /* Larger screens */\n  @media (min-width: 768px) {\n    .game-header-header-title.game-header-header-title-long-name {\n        font-size: 28px !important;\n        margin-right: 32px !important;\n    }\n  }\n\n\n  // .game-header-header-border {\n  //   width: 100%;\n  //   height: 4px;\n  //   flex-shrink: 0;\n  // }\n\n  .game-header-modal-buttons {\n    display: flex;\n    gap: 10px;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
